// extracted by mini-css-extract-plugin
module.exports = {"content":"ConfirmationModal_content__2Bn60","buttons":"ConfirmationModal_buttons__25m01"};